import { $ } from '../vendors/jquery';

class Sidebar
{
    constructor( element ) 
    {
        this.element     = element;
        this.buttonOpen  = this.element.find( '[data-element="sidebar-open"]' );
        this.buttonClose = this.element.find( '[data-element="sidebar-close"]' );
        this.holder      = this.element.find( '[data-element="sidebar-holder"]' );

        this.init();
    }

    init() 
    {
        window.matchMedia( '(min-width: 992px)' ).addEventListener( 'change', ( event ) => {
            if ( event.matches ) {
                this.closeSidebar();
            }
        } );

        this.buttonOpen.on( 'click', this.openSidebar );
        this.buttonClose.on( 'click', this.closeSidebar );
    }

    openSidebar() 
    {
        $( 'body' ).addClass( 'has-sidebar-open' );
    }

    closeSidebar() 
    {
        $( 'body' ).removeClass( 'has-sidebar-open' ); 
    }
}

const sidebar = {
    init() {
        const sidebarElement = $( '[data-module="sidebar"]' );

        if ( null !== sidebarElement ) {
            new Sidebar( $( sidebarElement ) );
        }
    }
};

export default sidebar;

$(document).ready(function() {
    $('#hide-ad-button').click(function() {
        $('#video-ad').hide();
    });
});

$(document).ready(function() {
    // Check if elements with the class .sidebar-ad exist
    if ($('.sidebar-ad').length > 0) {
        // Function to check if the sidebar's bottom is in the middle of the viewport
        function isSidebarBottomAtMiddle(el) {
            const elementBottom = $(el).offset().top + $(el).outerHeight();
            const viewportMiddle = $(window).scrollTop() + $(window).height() / 2;

            return elementBottom <= viewportMiddle;
        }

        // Function to check if the element is in the viewport
        function isInViewport(el) {
            const elementTop = $(el).offset().top;
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            return elementTop < viewportBottom;
        }

        // Function to check the visibility of the sidebar ad and adjust its visibility
        function checkAdVisibility() {
            const sidebarCondition = isSidebarBottomAtMiddle('.sidebar');
            const footerCondition = isInViewport('.footer');

            if (sidebarCondition && !footerCondition) {
                $('.sidebar-ad').stop().fadeIn(100);
            } else {
                $('.sidebar-ad').stop().fadeOut(100);
            }
        }

        // Attach the checkAdVisibility function to scroll and resize events
        $(window).on('resize scroll', checkAdVisibility);

        // Initial setup
        $('.sidebar-ad').hide();
        checkAdVisibility();
    }
});

// Sidebar Tabs
$(document).ready(function() {
    if ($('[id="sidebar-tabs"]').length > 0) {
        $('.sidebar__tabs-tab').click(function() {
            console.log('Tab clicked: ', this.id);
            const tabId = $(this).attr('id');
            $('.sidebar__tabs-tab').removeClass('active-tab');
            $(this).addClass('active-tab');
            $('.sidebar__tabs-content').removeClass('active-content');

            switch (tabId) {
                case 'sidebar-news':
                    $('#news-content').addClass('active-content');
                    break;
                case 'sidebar-tournament':
                    $('#tournament-content').addClass('active-content');
                    break;
                case 'sidebar-media':
                    $('#media-content').addClass('active-content');
                    break;
            }
        });
    }
});

$(document).ready(function() {
    // Check if the data-module "sidebar-tournaments" exists
    if ($('[data-module="sidebar-tournaments"]').length > 0) {
        // Sticky Sidebar
        const tournamentSidebar = $('.tournament-sidebar');
        const stickyBar = $('.tournament-sticky-bar');
        const container = tournamentSidebar.parent();
        const stickyPoint = 60;
        const offsetAboveStickyBar = 150;
        let lastScrollTop = 0; // Variable to track the last scroll position

        function setTournamentSidebarWidth() {
            const containerWidth = container.width();
            tournamentSidebar.width(containerWidth);
        }

        $(window).scroll(function() {
            const currentScrollTop = $(window).scrollTop();
            const stickyBarTopPos = stickyBar.offset().top;
            const sidebarBottomPos = tournamentSidebar.offset().top + tournamentSidebar.outerHeight();

            if (currentScrollTop >= stickyPoint) {
                if (sidebarBottomPos + offsetAboveStickyBar < stickyBarTopPos) {
                    setTournamentSidebarWidth();
                    tournamentSidebar.css({
                        'position': 'fixed',
                        'top': '125px'
                    });
                } else if (currentScrollTop < lastScrollTop) {
                    tournamentSidebar.css({
                        'position': 'fixed',
                        'top': '125px'
                    });
                } else {
                    tournamentSidebar.css({
                        'position': 'absolute',
                        'top': (stickyBarTopPos - tournamentSidebar.outerHeight() - offsetAboveStickyBar) + 'px'
                    });
                }
            } else {
                tournamentSidebar.css({
                    'position': 'absolute',
                    'top': '0',
                    'width': 'calc(100% - 24px)'
                });
            }

            lastScrollTop = currentScrollTop;
        });

        $(window).resize(function() {
            if ('fixed' === tournamentSidebar.css('position')) {
                setTournamentSidebarWidth();
            }
        });

        // Dynamic Sidebar Menu based off active sections on page
        $('section[id]').each(function() {
            const sectionId = $(this).attr('id');
            const menuTitle = $(this).data('menu-title');

            const listItem = $('<li class="tournament-sidebar__menu-item"></li>');
            const link = $('<a></a>', {
                'href': '#' + sectionId,
                'class': 'tournament-sidebar__menu-link',
                'text': menuTitle
            });

            listItem.append(link);
            $('#tournament-menu').append(listItem);
        });

        // Function to update active menu link
        function updateActiveMenuLink() {
            let scrollPosition = $(window).scrollTop();
            const halfwayPoint = $(window).height() / 3;

            if (0 === scrollPosition) {
                $('.tournament-sidebar__menu-link').removeClass('active');

                return;
            }

            scrollPosition += halfwayPoint;

            $('section[id]').each(function() {
                const section = $(this);
                const sectionId = section.attr('id');
                const sectionTop = section.offset().top;

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + section.height()) {
                    $('.tournament-sidebar__menu-link').removeClass('active');
                    $('a[href="#' + sectionId + '"]').addClass('active');
                }
            });
        }

        $(window).on('scroll', function() {
            updateActiveMenuLink();
        });

        updateActiveMenuLink();

        // Mobile sidebar toggle
        const openTournamentMenu = jQuery('#open-tournament-menu');
        const sidebarContent = jQuery('.tournament-sidebar__content');

        const barsSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- bars icon --><path fill="#ffffff" d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>'; // Your SVG code here
        const xmarkSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!-- xmark icon --><path fill="#ffffff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>'; // Your SVG code here

        openTournamentMenu.click(function() {
            sidebarContent.toggleClass('is-open');

            if (sidebarContent.hasClass('is-open')) {
                jQuery(this).html(xmarkSVG);
            } else {
                jQuery(this).html(barsSVG);
            }
        });
    }
    // Check if the .sidebar__mobile exsists
    if ($('[class="sidebar__mobile"]').length > 0) {
        // Mobile sidebar toggle
        const openTournamentMenu = jQuery('#open-tournament-menu');
        const sidebarContent = jQuery('.sidebar__mobile-content'); // Updated to match the class in your HTML

        const barsSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!-- bars icon --><path fill="#ffffff" d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>';
        const xmarkSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!-- xmark icon --><path fill="#ffffff" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>';

        openTournamentMenu.click(function() {
            sidebarContent.toggleClass('is-open');

            if (sidebarContent.hasClass('is-open')) {
                jQuery(this).html(xmarkSVG);
            } else {
                jQuery(this).html(barsSVG);
            }
        });
    }
});

